<template>
    <v-container>


        <v-snackbar v-model="alert" :timeout="6000" top color="white">
            <span :class="msgColor">{{msg}}</span>
        </v-snackbar>

        <div><h1 class="title ml-6" style="color:#033953">Add a Farm</h1></div>
        <v-row justify="center" align="center">
          <v-col cols="11">
            <v-stepper v-model="e1">
            <v-stepper-header >
            <v-stepper-step :complete="e1 > 1" step="1" color="#48c074"></v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="e1 > 2" step="2" color="#48c074"></v-stepper-step>

            
            </v-stepper-header>

            <v-stepper-items>
            <v-stepper-content step="1">
                <v-card
                    class="mb-9 pa-7 mx-auto"
                    >
                    <v-form ref="form">
                        <v-row no-gutters>
                            <v-col class="mt-2" cols="12" md="4" sm="6">
                                <span style="font-size:13px; color:#033953">Farm Name</span>
                                
                            </v-col>
                            <v-col  cols="12" md="8" sm="6">
                                <v-text-field
                                    type="text"
                                    solo
                                    flat
                                    dense
                                    v-model="name"
                                    class="black--text"
                                    :rules="nameRules"
                                    color="#48c074"
                                    background-color="#f5f3fc"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col class="mt-2" cols="12" md="4" sm="6">
                                <span style="font-size:13px; color:#033953">Cost</span>
                                
                            </v-col>
                            <v-col cols="12" md="8" sm="6">
                                <v-text-field
                                    type="number"
                                    solo
                                    flat
                                    dense
                                    v-model="cost"
                                    class="black--text"
                                    :rules="costRules"
                                    color="#48c074"
                                    background-color="#f5f3fc"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col class="mt-2" cols="12" md="4" sm="6">
                                <span style="font-size:13px; color:#033953">Duration</span>
                                
                            </v-col>
                            <v-col cols="12" md="8" sm="6">
                                <v-select
                                    solo
                                    flat
                                    dense
                                    label="Select a duration"
                                    v-model="duration"
                                    class="black--text"
                                    :rules="durationRules"
                                    color="#48c074"
                                    :items="period"
                                    background-color="#f5f3fc"
                                ></v-select>
                            </v-col>
                        </v-row >
                        <v-row no-gutters>
                            <v-col class="mt-2" cols="12" md="4" sm="6">
                                <span style="font-size:13px; color:#033953">Farm Location</span>
                                
                            </v-col>
                            <v-col cols="12" md="8" sm="6">
                                <v-textarea
                                    label=""
                                    type="text"
                                    solo
                                    flat
                                    dense
                                    v-model="location"
                                    class="black--text"
                                    :rules="locationRules"
                                    color="#002b49"
                                    background-color="#f5f3fc"
                                ></v-textarea>
                            </v-col>
                        </v-row >
                        <v-row no-gutters>
                            <v-col class="mt-2" cols="12" md="4" sm="6">
                                <span style="font-size:13px; color:#033953">Farm Description</span>
                                
                            </v-col>
                            <v-col cols="12" md="8" sm="6">
                                <v-textarea
                                    label=""
                                    type="text"
                                    solo
                                    flat
                                    dense
                                    v-model="desc"
                                    class="black--text"
                                    :rules="descRules"
                                    color="#002b49"
                                    background-color="#f5f3fc"
                                ></v-textarea>
                            </v-col>
                        </v-row >
                        
                    </v-form>
                </v-card>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="#48c074"
                        dark=""
                        rounded
                        @click="Continue()"
                        >
                          Continue
                    </v-btn>
                </v-card-actions>
    
                
            </v-stepper-content>

            <v-stepper-content step="2">
                <v-card
                class="mb-9 pa-7"
                >
                
                    <v-form ref="form2">
                        <v-row no-gutters>
                            <v-col class="mt-2" cols="12" md="4" sm="6">
                                <span style="font-size:13px; color:#033953">Units Available</span>
                                
                            </v-col>
                            <v-col cols="12" md="8" sm="6">
                                <v-text-field
                                    type="number"
                                    solo
                                    flat
                                    dense
                                    v-model="totalUnits"
                                    class="black--text"
                                    color="#002b49"
                                    :rules="unitRules"
                                    background-color="#f5f3fc"
                                ></v-text-field>
                            </v-col>
                        </v-row >
                        <v-row no-gutters>
                            <v-col class="mt-2" cols="12" md="4" sm="6">
                                <span style="font-size:13px; color:#033953">ROI(%)</span>
                                
                            </v-col>
                            <v-col cols="12" md="8" sm="6">
                                <v-text-field
                                    type="text"
                                    solo
                                    flat
                                    dense
                                    v-model="roi"
                                    class="black--text"
                                    :rules="roiRules"
                                    color="#002b49"
                                    background-color="#f5f3fc"
                                ></v-text-field>
                            </v-col>
                        </v-row >
                        <v-row no-gutters>
                            <v-col class="mt-2" cols="12" md="4" sm="6">
                                <span style="font-size:13px; color:#033953">Category</span>
                                
                            </v-col>
                            <v-col cols="12" md="8" sm="6">
                                <v-autocomplete
                                    label="Select a Category"
                                    height="10"
                                    :items="categories"
                                    solo
                                    dense flat 
                                    class="mt-2"
                                    background-color="#f5f3fc"
                                    item-text="categoryName"
                                    item-value="categoryName"
                                    v-model="category"
                                    :rules="categoryRules"
                                    
                                ></v-autocomplete>
                            </v-col>
                        </v-row >
                        <v-row no-gutters>
                            <v-col class="mt-2" cols="12" md="4" sm="6">
                                <span style="font-size:13px; color:#033953">Upload Cover Image</span>
                                
                            </v-col>
                            <v-col cols="12" md="8" sm="6">
                              <!-- <v-file-input accept='image/*' label="Upload advert image"  color="#002b49" background-color="#f5f3fc" solo flat dense :rules="imageRules" @change="getImageUrl($event)"></v-file-input> -->
                              <input accept='image/*' type="file" @change="onFileChange" class="mt-n4" />
                              <div id="preview" class="mt-5">
                                  <!-- <img v-if="url" :src="url" alt=""> -->
                                <v-img  :src="url" alt="" v-if="url"></v-img>
                              </div>
                              <p class="green--text mt-n6 pt-0" v-if="disabled">please wait, uploading farm image...<span class="fa fa-circle-o-notch fa-spin"></span></p>
                            </v-col>
                        </v-row >
                        
                    </v-form>
                
                </v-card>

                <v-card-actions>
                    <v-spacer>
                        
                    </v-spacer>
                      <v-btn
                        @click="e1=1"
                        text
                        dark
                        color="#48c074"
                        >
                        Back
                    </v-btn>
                     <v-btn
                        @click="verifySecondForm()"
                        rounded
                        style="color: white;"
                        :disabled="verify"
                        color="#48c074"
                        :loading="loading"
                        >
                        Submit
                    </v-btn>
                </v-card-actions>

            </v-stepper-content>

            
            </v-stepper-items>
        </v-stepper>
          </v-col>
        </v-row>
        
        
    </v-container>
</template>

<script>
export default {
  data(){
    return{
      name: '',
      cost: 0,
      duration: '',
      category: '',
      desc: '',
      location: '',
      totalUnits: '',
      roi: 0,
      e1:1,
      period:['1 month', '2 months','3 months','4 months','5 months','6 months','7 months','8 months','9 months','10 months', '11 months', '12 months' ],
      categories: ['farm', 'commodity'],
      url:null,
      nameRules:[v => !!v || 'Farm name is required'],
      costRules:[v => !!v || 'Cost is required'],
      durationRules:[v => !!v || 'Duration is required'],
      locationRules:[v => !!v || 'Location of farm is required'],
      descRules:[v => !!v || 'Description is required'],
      unitRules:[v => !!v || 'Unit is required'],
      roiRules:[v => !!v || 'ROI is required'],
      categoryRules:[v => !!v || 'Category is required'],
      verify: true,
      disabled: false,
      farmUrl: '',
      loading: false,
      alert: false,
      msgColor: '',
      msg: '',
    }
  },
  methods:{
    onFileChange(e) {
        const file = e.target.files[0];
        this.img = e.target.files[0];
        this.url = URL.createObjectURL(file);
        if(file){
         this.disabled=true
            this.$store.dispatch("GetImageUrl", {'file': file})
            .then((success)=>{
                this.verify= false
              this.disabled = false
            this.farmUrl = success.data.data
            })
            .catch(()=>{
                    this.verify = true
                    this.disabled = false
            })
        }
    },
    Continue(){
        if (this.$refs.form.validate()){
            this.e1 = 2
        }
    },
    verifySecondForm(){
         if (this.$refs.form2.validate()){
             this.loading = true
             this.$store.dispatch("AddFarm", {
                    "name": this.name,
                    "cost": this.cost,
                    "duration": this.duration, 
                    "location": this.location, 
                    "roi": this.roi, 
                    "farm_img_url": this.farmUrl, 
                    "description": this.desc, 
                    "units_avail": this.totalUnits, 
                    "category": this.category, 
                })
                .then(()=>{
                    this.loading = false
                    this.verify= true
                    this.e1 = 1
                    this.msgColor='green--text'
                    this.msg=`Farm successfully added`
                    this.alert=true
                    this.name = ''
                    this.cost = ''
                    this.location = ''
                    this.duration = ''
                    this.roi = ''
                    this.desc = ''
                    this.category = ''
                    this.totalUnits= ''
                })
                .catch((error)=>{
                    this.msgColor='red--text'
                    this.msg=error.response.data.message.toUpperCase()
                    this.color='red'
                    this.alert=true
                    this.loading = false
                })
         }
    }
  }
}
</script>

<style scoped>
  #preview{
        display: flex;
        justify-content: center;
        align-items: center;
    }

    #preview img{
        max-width: 100%;
        max-height: 500px
    }
</style>